import { useGetUncheckedNoticeCountQuery } from '../../../api/rtk-query/loungeBoardApi'

const LoungeBoardNoticeTitle = () => {
  const { data = { count: 0 } } = useGetUncheckedNoticeCountQuery(undefined, {
    refetchOnFocus: true,
  })
  return (
    <>
      공지사항{data.count > 0 && <span className="ico_gnb ico_new">new</span>}
    </>
  )
}
export default LoungeBoardNoticeTitle
